import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  logoutAsync,
  selectIsAuthenticated,
  selectUserProfile,
} from "../../features/authentication/authenticationSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { ROUTES } from "../../routes/routes";

const Header = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const user = useAppSelector(selectUserProfile);
  const dispatch = useAppDispatch();

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    await dispatch(logoutAsync());
  };

  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  return (
    <AppBar position="static" sx={{ backgroundColor: "#1976d2" }}>
      <Toolbar>
        <Typography
          variant="h6"
          component="div"
          onClick={() => navigate("/")}
          sx={{ cursor: "pointer", flexGrow: 1 }}
        >
          Team Ray
        </Typography>
        {isAuthenticated ? (
          <>
            <IconButton onClick={handleMenuOpen} sx={{ p: 0 }}>
              <Avatar alt="User Image" src={user.picture} />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              {user.name && (
                <MenuItem disabled>{user.name || "Unknown User"}</MenuItem>
              )}

              <MenuItem disabled>{user.emailaddress || "No Email"}</MenuItem>
              {user.role === "Admin" && (
                <MenuItem
                  onClick={() => navigate(ROUTES.USER_PROJECT_ACCESSES)}
                >
                  User Projects Access
                </MenuItem>
              )}
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </>
        ) : (
          <></>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
